import { motion } from "framer-motion";

const EASE = [0.16, 1, 0.3, 1];

export function Reveal({ children, delay = 0, className = "", y = 30 }) {
  return (
    <motion.div
      className={className}
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-50px" }}
      transition={{ duration: 0.8, delay, ease: EASE }}
    >
      {children}
    </motion.div>
  );
}

export function MaskedLine({ children, delay = 0, className = "", as = "span" }) {
  const Tag = as;
  return (
    <Tag className={`block overflow-hidden ${className}`}>
      <motion.span
        className="block will-change-transform"
        initial={{ y: "115%" }}
        animate={{ y: 0 }}
        transition={{ duration: 1.05, delay, ease: EASE }}
      >
        {children}
      </motion.span>
    </Tag>
  );
}

export function Overline({ children, className = "", testId }) {
  return (
    <p
      data-testid={testId}
      className={`font-mono text-xs font-medium uppercase tracking-[0.32em] text-[#C5A059] ${className}`}
    >
      {children}
    </p>
  );
}
